import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC } from 'react';

import { SvgIconPerformance2 } from '@/components/assets/IconPerformance_2';
import { SvgIconPin } from '@/components/assets/IconPin';
import { SvgIconHeart } from '@/components/common/ButtonWithIcon/IconHeart';
import { roundUpByDigit } from '@/utils/math';

interface Props {
  companyName: string;
  nftName: string;
  address: string;
  imageUrl: string;
  power: number;
  count: number;
  onClick?: () => void;
  // TODO: Lot毎のyellCountのクエリができたらisDisplayYellCountの記載全削除
  isDisplayYellCount?: boolean;
}

const NftItem: FC<Props> = ({
  companyName,
  nftName,
  address,
  imageUrl,
  power,
  count,
  isDisplayYellCount,
  onClick,
}) => {
  const router = useRouter();
  const { lng } = router.query;

  return (
    <Flex
      h="170px"
      w="full"
      boxShadow={onClick ? '0 4px 16px rgba(0, 0, 0, 0.16)' : 'none'}
      rounded="9px"
      cursor={onClick ? 'pointer' : 'default'}
      onClick={onClick}
      borderWidth={onClick ? '0' : '2px'}
      borderColor="stroke.lightGray"
      p={2}
    >
      <Box w="96px" h="full" position="relative">
        <Image
          alt="myNft"
          src={imageUrl}
          fill
          style={{
            objectFit: 'contain',
          }}
        />
      </Box>
      <Flex
        p="16px 0 16px 16px"
        h="full"
        flex={1}
        flexDirection="column"
        justifyContent="space-between"
      >
        <VStack align="flex-start" gap={1}>
          <Text lineHeight={1.2} fontSize="xs">
            {companyName}
          </Text>
          <Text lineHeight={1.2} fontSize="sm" fontWeight="bold">
            {nftName}
          </Text>
          <Flex mt="4px" w="full">
            <Box>
              <SvgIconPin />
            </Box>
            <Text lineHeight={1.2} ml="1" fontSize="xs" flex={1} noOfLines={1}>
              {address}
            </Text>
          </Flex>
          <Flex>
            <Box mt="3px">
              <SvgIconPerformance2 />
            </Box>
            <HStack gap={0}>
              <Text ml="1" fontSize="xs" flex={1} noOfLines={2}>
                {`${roundUpByDigit(power, 2)}kg/day`}
              </Text>
            </HStack>
          </Flex>
        </VStack>
        {!isDisplayYellCount && (
          <Flex justifyContent="flex-end" alignItems="center">
            <Flex alignItems="center">
              <SvgIconHeart fill="#EF6762" size="14px" />
              <Text lineHeight={1.2} fontSize="ml" fontWeight="medium" ml="4px">
                {count || 0}
              </Text>
              <Text
                lineHeight={1.2}
                fontSize="xs"
                fontWeight="medium"
                mt="auto"
                mb="2px"
                ml="2px"
              >
                {`${
                  lng === 'ja' ? '回' : (count || 0) <= 1 ? 'Time' : 'Times'
                }`}
              </Text>
            </Flex>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export { NftItem };
